import { Injectable } from '@angular/core';
import { ProductOfTheMonthAdapter } from './product-of-the-month.adapter';
import { Observable } from 'rxjs';
import { Product } from '@spartacus/core';

@Injectable()
export class ProductOfTheMonthConnector {
  constructor(protected adapter: ProductOfTheMonthAdapter) {}

  get(): Observable<Product> {
    return this.adapter.load() as Observable<Product>;
  }
}
